import React, { useEffect, useState } from 'react';

import { offMarketPropertyUrl } from 'bundles/connect/helpers/connect_api';
import DetailModal from './detail_modal';

export default function PropertyModalContainer() {
  const [propertyId, setPropertyId] = useState();

  useEffect(() => {
    const showPropertyDetails = (event) => {
      const { eventName, payload } = event?.data || {};

      if (eventName !== 'pn-property-details') return;

      setPropertyId(payload.id);
    };

    window.addEventListener('message', showPropertyDetails);

    return () => window.removeEventListener('message', showPropertyDetails);
  }, []);

  const src = propertyId ? offMarketPropertyUrl(propertyId) : null;

  return <DetailModal src={src} onHide={() => setPropertyId()} />;
}
